var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMyVotesBlueCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.99993 10.8L3.19993 8L2.2666 8.93334L5.99993 12.6667L13.9999 4.66667L13.0666 3.73334L5.99993 10.8Z",
    fill: "#4569FF"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyVotesBlueCheckmark);
export default __webpack_public_path__ + "static/media/my-votes-blue-checkmark.ee8f6b1b59e5a689d0bc43b4c3b8b3c6.svg";
export { ForwardRef as ReactComponent };